const formationReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_FORMATION':
      return action.data
    default:
      return state
  }
}

export default formationReducer
